import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { ResponseFailModal } from '../../modal/Response';
import { SMSSend } from '../../SMSSend';
import Spin from '../../Spin';
import countryInfo from '../../../assets/countries.json';
import * as api from '../../../api';

const StaffkeyIssue = ({
  isOpen,
  toggle,
  reload,
  staffId,
}) => {
  const { t } = useTranslation();
  const hotelId = localStorage.getItem('hotel_id');
  const countryInfoList = Object.values(countryInfo);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ countryNumber, setCountryNumber ] = useState('82');
  const [ isOpenStaffkeyIssueSuccessModal, setIsOpenStaffkeyIssueSuccessModal ] = useState(false);
  const [ isOpenStaffkeyIssueFailModal, setIsOpenStaffkeyIssueFailModal ] = useState(false);
  const [ messageStaffkeyIssueFail, setMessageStaffkeyIssueFail ] = useState('');
  const [ buildingItems, setBuildingItems ] = useState([]);
  const [ roomItems, setRoomItems ] = useState([]);
  const [ commonroomItems, setCommonroomItems ] = useState([]);
  const [ selectedBuildingId, setSelectedBuildingId ] = useState('');
  const [ keyIssueItem, setKeyIssueItem ] = useState({
    roomIds: [],
    commonroomIds: [],
    isNew: false,
    startAt: '',
    endAt: '',
  });
  const [ SMSSendItem, setSMSSendItem ] = useState({
    phoneNumber: '',
    type: 'mobilekey',
    value: '',
  });
  const [ staffItem, setStaffItem ] = useState({
    name: '',
    phoneNumber: '',
  });

  const changeKeyStartAt = (date) => {
    date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      startAt: date,
    });
  };

  const changeKeyEndAt = (date) => {
    date.setSeconds(0, 0);
    setKeyIssueItem({
      ...keyIssueItem,
      endAt: date,
    });
  };

  const changeRoom = (selectedRooms) => {
    setKeyIssueItem({
      ...keyIssueItem,
      roomIds: selectedRooms ? selectedRooms.map(room => room.value) : [],
    });
  };

  const changeCommonroom = (selectedCommonrooms) => {
    setKeyIssueItem({
      ...keyIssueItem,
      commonroomIds: selectedCommonrooms ? selectedCommonrooms.map(commonroom => commonroom.value) : [],
    });
  };

  const issueKey = async () => {
    try {
      setIsLoading(true);
      const res = await api.issueStaffMobilekey({staffId, ...keyIssueItem});
      setSMSSendItem({
        ...SMSSendItem,
        phoneNumber: '82' + Number.parseInt(staffItem.phoneNumber),
        value: res.data.exchangekey,
      });
      setIsOpenStaffkeyIssueSuccessModal(true);
    } catch (error) {
      if (!error.response) setMessageStaffkeyIssueFail(error.message);
      else setMessageStaffkeyIssueFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenStaffkeyIssueFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const listCommonroom = async () => {
      try {
        const res = await api.listCommonroomDoorlock({buildingId: selectedBuildingId});
        setCommonroomItems(res.data.map(commonroom => {
          return {value: commonroom.id, label: commonroom.name,  isDisabled: commonroom.status !== 'installed'};
        }));
      } catch (error) {
        throw error;
      }
    };
    if (selectedBuildingId) listCommonroom();
  }, [hotelId, selectedBuildingId]);

  useEffect(() => {
    const listRoom = async () => {
      try {
        setIsLoading(true);
        const res = await api.listRoom({buildingId: selectedBuildingId});
        setRoomItems(res.data.items.map(room => {
          return {value: room.id, label: room.name, isDisabled: room.status !== 'installed'};
        }));
      } catch (error) {
        throw error;
      } finally {
        setIsLoading(false);
      }
    };
    if (selectedBuildingId) listRoom();
  }, [hotelId, selectedBuildingId]);

  useEffect(() => {
    const listBuilding = async () => {
      try {
        const res = await api.listBuilding({});
        setBuildingItems(res.data.items);
      } catch (error) {
        throw error;
      }
    };
    if (hotelId) listBuilding();
  }, [hotelId]);

  useEffect(() => {
    const selectStaff = async () => {
      try {
        const res = await api.selectStaff({staffId});
        setStaffItem({
          name: res.data.name,
          phoneNumber: res.data.phone_number.replace(/([0-9]*)(\d{10})/, '0$2'),
        });
        setCountryNumber(res.data.phone_number.replace(/([0-9]*)(\d{10})/, '$1'));
      } catch (error) {
        throw error;
      }
    };
    if (staffId) selectStaff();
  }, [staffId]);

  useEffect(() => {
    const init = () => {
      setKeyIssueItem({
        roomIds: [],
        commonroomIds: [],
        isNew: false,
        startAt: '',
        endAt: '',
      });
      setSelectedBuildingId('');
    };
    init();
  }, [isOpen]);

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
        size='md'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3' style={{margin:0, padding:0, backgroundColor:'#282C34'}}>
          <div className='form-card'>
            <div className='form-card-title'>
              <h4>{t('content_title.staffkey_issue')}</h4>
            </div>
            <div className='inline-flex'>
              <div className='w-100'>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.building')}</b>
                    <span className='required'>*</span>
                  </p>
                  <select
                    className='card-text-select'
                    value={selectedBuildingId}
                    onChange={e => setSelectedBuildingId(e.target.value)}
                  >
                    <option value='' hidden>{t('placeholder.building_select')}</option>
                    {buildingItems.map((building, index) => (
                      <option key={index} value={building.id}>{building.name}</option>
                    ))}
                  </select>
                </div>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.room')}</b>
                    <span className='required'>*</span>
                  </p>
                  <Select
                    styles={{
                      menu: (provided) => ({...provided, backgroundColor:'#1c2025'}),
                      option: (provided, state) => ({...provided, backgroundColor:'#1c2025', color:state.isDisabled ? '#68696d':'#e6e5e8', '&:hover':{backgroundColor:state.isDisabled ? '':'rgba(255, 255, 255, 0.04)'}})
                    }}
                    placeholder={t('placeholder.room_select')}
                    noOptionsMessage={() => ''}
                    isMulti
                    vlaue={keyIssueItem.roomIds || []}
                    onChange={(state) => changeRoom(state)}
                    closeMenuOnSelect={false}
                    name='rooms'
                    options={roomItems}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.commonroom_name')}</b>
                  </p>
                  <Select
                    styles={{
                      menu: (provided) => ({...provided, backgroundColor:'#1c2025'}),
                      option: (provided, state) => ({...provided, backgroundColor:'#1c2025', color:state.isDisabled ? '#68696d':'#e6e5e8', '&:hover':{backgroundColor:state.isDisabled ? '':'rgba(255, 255, 255, 0.04)'}})
                    }}
                    placeholder={t('placeholder.commonroom_select')}
                    noOptionsMessage={() => ''}
                    isMulti
                    vlaue={keyIssueItem.commonroomIds || []}
                    onChange={(state) => changeCommonroom(state)}
                    closeMenuOnSelect={false}
                    name='commonrooms'
                    options={commonroomItems}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.staff_name')}</b>
                    <span className='required'>*</span>
                  </p>
                  <input
                    className='card-text-input'
                    placeholder={t('placeholder.staff_name')}
                    value={staffItem.name}
                    disabled
                  />
                </div>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.phone_number')}</b>
                    <span className='required'>*</span>
                  </p>
                  <select
                    className='card-text-select'
                    value={countryNumber}
                    disabled
                  >
                    {countryInfoList.map((country, index) => (
                      <option key={`country-index-${index}`} value={country.phone}>{`${country.name} ( +${country.phone} )`}</option>
                    ))}
                  </select>
                  <p></p>
                  <input
                    className='card-text-input'
                    placeholder={t('placeholder.phone_number')}
                    value={staffItem.phoneNumber}
                    maxLength='11'
                    disabled
                  />
                </div>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.start_at')}</b>
                    <span className='required'>*</span>
                  </p>
                  <DatePicker
                    dateFormat='yyyy-MM-dd HH:mm'
                    placeholderText={t('placeholder.start_at')}
                    selected={keyIssueItem.startAt}
                    selectsStart
                    minDate={new Date()}
                    endDate={keyIssueItem.endAt}
                    showTimeSelect
                    timeFormat='HH:mm'
                    timeIntervals={60}
                    timeCaption='Time'
                    onChange={date => changeKeyStartAt(date)}
                    withPortal
                  />
                </div>
                <div className='card-text'>
                  <p>
                    <b>{t('data_column.end_at')}</b>
                    <span className='required'>*</span>
                  </p>
                  <DatePicker
                    disabled={!keyIssueItem.startAt}
                    dateFormat='yyyy-MM-dd HH:mm'
                    placeholderText={t('placeholder.end_at')}
                    selected={keyIssueItem.endAt}
                    selectsEnd
                    minDate={keyIssueItem.startAt}
                    startDate={keyIssueItem.startAt}
                    showTimeSelect
                    timeFormat='HH:mm'
                    timeIntervals={60}
                    timeCaption='Time'
                    onChange={date => changeKeyEndAt(date)}
                    withPortal
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='card-foot'>
            <div className='form-item-cancel'>
              <button className='btn-item-cancel' onClick={() => toggle()}>
                <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>{t('button.cancel')}</span>
              </button>
            </div>
            <div className='form-item-add center'>
              <button className='btn-item-add' onClick={issueKey}>
                <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>{t('button.save')}</span>
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <SMSSend
        isOpen={isOpenStaffkeyIssueSuccessModal}
        toggle={() => setIsOpenStaffkeyIssueSuccessModal(!isOpenStaffkeyIssueSuccessModal)}
        smsSendItem={SMSSendItem}
        reload={() => {
          reload();
          toggle();
        }}
      />
      <ResponseFailModal
        isOpen={isOpenStaffkeyIssueFailModal}
        toggle={() => setIsOpenStaffkeyIssueFailModal(!isOpenStaffkeyIssueFailModal)}
        message={messageStaffkeyIssueFail || t('error_message.issue_staffkey')}
      />
    </Fragment>
  );
};

export default StaffkeyIssue;